import { requestMain } from "../../apis";
import localStorageKey from "../../enumerations/localStorageKey";

const defaultCurrency = localStorage.getItem(localStorageKey.DEFAULT_CURRENCY);

export const apiGetSettings = ({ params }) =>
  requestMain("get", `/${defaultCurrency}/setting`, params, false, false);
